module.exports = __webpack_public_path__ + "static/img/Heilum-Luki.986f84a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Heilum-Luki.jpg
// module id = J9E6
// module chunks = 0